import { cn } from "@/lib/utils";
import { Building2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { INDUSTRIES, type LeadFormData } from "../types";

interface Props {
  data: LeadFormData;
  onChange: (patch: Partial<LeadFormData>) => void;
  onAdvance?: () => void;
}

export function StepIndustry({ data, onChange, onAdvance }: Props) {
  const isOther = data.industry === "Other";

  return (
    <div className="space-y-6">
      <div className="space-y-3">
        <div className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.18em] text-brand-blue">
          <Building2 className="h-4 w-4" />
          Your Industry
        </div>
        <h2 className="text-balance text-3xl font-bold tracking-tighter text-foreground sm:text-4xl">
          What type of business do you run?
        </h2>
        <p className="text-base text-muted-foreground">
          This helps us understand your market and what your customers expect.
        </p>
      </div>

      <div className="grid grid-cols-2 gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {INDUSTRIES.map((industry) => {
          const selected = data.industry === industry;
          return (
            <button
              key={industry}
              type="button"
              onClick={() => {
                onChange({ industry });
                if (industry !== "Other") {
                  onAdvance?.();
                }
              }}
              className={cn(
                "rounded-xl border bg-background px-4 py-4 text-left text-sm font-medium text-gray-950 transition-all",
                "hover:border-brand-blue hover:shadow-sm",
                selected
                  ? "border-brand-blue bg-brand-blue/5 ring-2 ring-brand-blue/30"
                  : "border-border",
              )}
            >
              {industry}
            </button>
          );
        })}
      </div>

      {isOther && (
        <div className="space-y-2">
          <label className="text-sm font-semibold text-foreground">
            Tell us what kind of business you run <span className="text-brand-blue">*</span>
          </label>
          <Input
            value={data.industryOther ?? ""}
            onChange={(e) => onChange({ industryOther: e.target.value })}
            placeholder="e.g. Mobile dog grooming"
            maxLength={100}
            className="h-12 rounded-xl"
            autoFocus
          />
        </div>
      )}
    </div>
  );
}
